import { render } from "./index.vue?vue&type=template&id=23e9e470&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=23e9e470&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e9e470"]])

export default __exports__